import * as e from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/FilePng.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(n, { ref: t, ...r, weights: a }));
o.displayName = "FilePngIcon";
const c = o;
export {
  c as FilePng,
  o as FilePngIcon
};
